<template>
  <div>
    <job-header-simple header_title="发票详情" left_text="" :part_background="true"></job-header-simple>
    <div class="header">
    </div>
    <div class="invoice-info">
      <div class="title"><span>开票信息</span><span :class="statusClass">{{statusName}}</span></div>
      <van-cell-group>
        <van-cell title="开票公司" :value="detail.ocompanyName" />
        <van-cell title="发票类型" :value="detail.receiptStatus==1?'增值税普票':'增值税专票'" />
        <van-cell title="发票内容" :value="detail.receiptContentName" />
        <van-cell title="开票金额" :value="detail.receiptTotalAmount" class="money"/>
        <van-cell title="申请时间" :value="getYMDHMS(detail.createDate)"/>
        <van-cell v-if="show2" title="开票时间" :value="detail.receiptDate" />
        <van-cell v-if="show2" title="发票编号" :value="detail.receiptCode" />
        <van-cell v-if="show2&&detail.receiptImage" title="发票文件" :value='downText' value-class="check" @click="lookPreview(detail.receiptImage)">
           <!-- <template #label>
              <img
                @click="lookPreview(detail.receiptImage)"
                :src="detail.receiptImage"
              />
          </template> -->
        </van-cell>
      </van-cell-group>
    </div>
    <div class="invoice-title">
      <div class="title">发票抬头</div>
      <van-cell-group>
        <van-cell title="发票抬头" :value="detail.receiptTitle" />
        <van-cell title="纳税人识别号" :value="detail.taxIdNumber" />
        <van-cell title="联系电话" :value="detail.receiptPhone" />
        <van-cell title="开户银行" :value="detail.receiptBankName" />
        <van-cell title="银行账号" :value="detail.receiptBankAccount" />
        <van-cell title="公司地址" :value="detail.receiptAddr"/>
      </van-cell-group>
    </div>
    <div class="receipt-info">
      <div class="title">收件信息</div>
      <van-cell-group>
        <van-cell title="收 件 人" :value="detail.receiveUser" />
        <van-cell title="联系电话" :value="detail.receiveMobile" />
        <van-cell title="邮箱" :value="detail.email" />
        <van-cell title="联系地址" :value="detail.receiveAddress" />
        <van-cell v-if="show2"  title="快递公司" :value="kuaidiCompany" />
        <van-cell v-if="show2"  title="快递单号" :value="detail.expressNo?detail.expressNo:'-'" />
      </van-cell-group>
    </div>
    <div class="receipt-info" v-if="show3">
      <div class="title">审核信息</div>
      <van-cell-group>
        <van-cell title="审核时间" :value="getYMDHMS(detail.modifyDate)" v-if="!show4"/>
        <van-cell title="审核理由" :value="detail.auditReason?detail.auditReason:'-'" v-if="!show4"/>
        <van-cell title="审核理由" :value="detail.cancelReason?detail.cancelReason:'-'" v-else/>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
import { Row,Col,Icon,Cell,Divider,CellGroup,Dialog,ImagePreview    } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import {
  recordDetailHttpAction,
} from "@/api/recordDetail/request";
import api from "@/api/list";

export default {
  components: {
    [Row.name]: Row,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Dialog.name]: Dialog,
    [ImagePreview.Component.name]: ImagePreview.Component,
    jobHeaderSimple
  },
  created() {
    recordDetailHttpAction(this.$route.query.id).then(res => {
      if (res.data.status == "200") {
        this.detail = res.data.data;
        if(res.data.data.receiptImage){
            if(res.data.data.receiptImage.endsWith('rar')||res.data.data.receiptImage.endsWith('zip')){
            this.isRar = true;
            this.downText = "下载"
            }
            if(res.data.data.receiptImage.endsWith('pdf')){
            this.isDpf = true;
            }
        }
        api.expressCompanyGroup().then(res => {
          let data = res.data.data;
          data.forEach(element => {
            if (this.detail.expressCompany==element.code) {
              this.kuaidiCompany = element.value?element.value:'-';
            }
          });
        })
      }
    });
    let status  = this.$route.query.receiptStatus;
    this.statusClass = this.$route.query.statusClass;
    if (status==3||status==4) {
      this.show2 = true;
      // show2 3:已开票 4:已寄出
    }else if(status==5){
      this.show3 = true;
       // show3 5:已驳回  
    }else if(status==6){
      // 6已作废
      this.show3 = true;
      this.show4 = true;
    }
    this.statusName = this.$route.query.statusName;
  },
  data() {
    return {
      detail:{},
      statusName:'待审核',
      statusClass:'audit',
      show2: false,
      show3: false,
      show4: false,
      isRar: false, //是不是压缩文件
      isDpf: false, //是不是pdf文件
      downText:"查看",
      kuaidiCompany:''
    };
  },
  methods: {
    getYMDHMS (timestamp) {
      let time = new Date(timestamp)
      let year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, '0')
      const date = (time.getDate()).toString().padStart(2, '0')
      const hours = (time.getHours()).toString().padStart(2, '0')
      const minute = (time.getMinutes()).toString().padStart(2, '0')
      const second = (time.getSeconds()).toString().padStart(2, '0')
      return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
    },
    lookPreview(src){
      
      let imgSrc = process.env.VUE_APP_FILE_PATH+src;
      if(this.isRar){ //压缩文件下载文件
        window.location.href = imgSrc;
      }else if(this.isDpf){ //是pdf
          this.$router.push({
              path: "/partner_checkContract",
              query: {
                fileURL: imgSrc,
                header_title:"查看发票文件"
              },
            });
      }else{
        ImagePreview({
            images: [
            imgSrc,
            ],
        showIndex:false,
        closeable: true
        });
      }
 
    }
  }
};
</script>

<style lang="less" scoped>
.header{
    width: 100%;
    height: 3.46rem;
    background-color: #6275f0;
}

.invoice-info{
  width: 90%;
  overflow-y: scroll;
  margin: -2.72rem auto 0;
	background-color: #ffffff;
	border-radius: 12px;
  position: relative;
  padding: 0.2rem;
  padding-bottom: 0.4rem;
  img{
    width: 100%;
    height: 5rem;
  }
  .check{ //待审核  1
    color: #f77a1e
  }
  .title{
    font-size: 0.37rem;
    color: #6275f0;
    padding: 0.4rem 0.4rem;
    display: flex;
    justify-content: space-between;
    // （1:等待开票 2:开票中 3:已开票 4:已寄出 5:已驳回 6:已作废 7:已撤销）
    .audit{ //待审核  1
      color: #f77a1e
    }
    .invoicing{ //开票中 234
      color: #6275f0;
    }
    .reject{  //已驳回 567
      color: #f14a59;
    }
  }
  /deep/ .van-cell__value{
    flex: 2;
  }
  .money{
    /deep/ .van-cell__value{
      color: red;
    }
  }
}
.invoice-title{
  width: 90%;
	min-height: 8.6rem;
  overflow-y: scroll;
  margin: 0.24rem auto 0;
	background-color: #ffffff;
	border-radius: 12px;
  position: relative;
  padding: 0.2rem;
  .title{
    font-size: 0.37rem;
    color: #6275f0;
    padding: 0.4rem 0.4rem;
  }
  /deep/ .van-cell__value{
    flex: 2;
  }
}
.receipt-info{
  width: 90%;
  overflow-y: scroll;
  margin: 0.24rem auto;
	background-color: #ffffff;
	border-radius: 12px;
  position: relative;
  padding: 0.2rem;
  padding-bottom: 0.4rem;
  .title{
    font-size: 0.37rem;
    color: #6275f0;
    padding: 0.4rem 0.4rem;
  }
  /deep/ .van-cell__value{
    flex: 2;
  }
}
</style>